<template>
  <AppLink
    to="/"
    class="logo"
  >
    <img
      src="/woonboulevard-poortvliet.svg"
      alt="Woonboulevard Poortvliet"
      class="logo__image"
      height="35"
      width="191"
      decoding="auto"
      loading="eager"
      fetchpriority="high"
    >
  </AppLink>
</template>

<style>
@import url("~layers/app/components/App/Logo.css");
</style>
